import { ItemProps } from 'interface/menu/menuInfo';
import { BiDetail } from 'react-icons/bi';

const menuIcons = {
  BiDetail,
};
const management: ItemProps = {
  id: 'manager',
  title: '',
  type: 'group',
  children: [
    {
      id: 'project',
      title: '프로젝트',
      type: 'item',
      url: '/manager/member-management',
      icon: menuIcons.BiDetail,
    },
  ],
};

export default management;
